import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Lock, User } from "lucide-react";
import { Input } from "@/components/ui/input";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LOGO_URL = "/logo.png";

export default function AdminLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await axios.post(`${API}/admin/login`, { username, password }, { withCredentials: true });
      navigate("/admin/dashboard");
    } catch (err) {
      setError(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <div className="flex flex-col items-center mb-10">
          <img src={LOGO_URL} alt="Vicki Ann's" className="w-48 mb-6" />
          <h1 className="font-playfair text-[#D4AF37] text-2xl font-bold">Admin Panel</h1>
          <div className="gold-line w-16 mt-3" />
        </div>

        <form onSubmit={handleSubmit} className="space-y-5" data-testid="admin-login-form">
          {error && (
            <div className="bg-red-900/30 border border-red-500/30 text-red-300 text-sm px-4 py-3 rounded-lg font-montserrat" data-testid="admin-login-error">
              {error}
            </div>
          )}

          <div className="relative">
            <User className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#D4AF37]/40" />
            <Input
              data-testid="admin-username-input"
              className="bg-black/50 border-[#D4AF37]/30 focus:border-[#D4AF37] text-white pl-10 h-12 font-montserrat placeholder:text-white/30"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>

          <div className="relative">
            <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#D4AF37]/40" />
            <Input
              data-testid="admin-password-input"
              type="password"
              className="bg-black/50 border-[#D4AF37]/30 focus:border-[#D4AF37] text-white pl-10 h-12 font-montserrat placeholder:text-white/30"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="btn-gold w-full py-3 rounded-full text-sm font-montserrat disabled:opacity-50"
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>

        <div className="text-center mt-8">
          <a href="/" className="font-montserrat text-white/30 text-xs tracking-wider hover:text-[#D4AF37] transition-colors">
            Back to Website
          </a>
        </div>
      </div>
    </div>
  );
}
